import { useIntl } from 'react-intl'

import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import { BasicDialog } from '@rent/ui'
import { ReactComponent as FileImg } from 'assets/images/fileImg.svg'
// import SmileImg2 from 'assets/images/smileImg.svg'
import { ReactComponent as SmileImg } from 'assets/images/smileImg.svg'

import { containerStyle, contentStyle } from './styles'
import { AdditionalService } from '../../../../../models'

interface SafeUpChangeConfirmationProps {
  handleSetSafeUpPlus: (safeupPlusTaken: boolean) => void
  setOpenDialog: (value: React.SetStateAction<boolean>) => void
  blockingAdditionalServices: AdditionalService[];
}
export const SafeUpChangeConfirmation = ({ handleSetSafeUpPlus, setOpenDialog, blockingAdditionalServices }: SafeUpChangeConfirmationProps) => {
  const { formatMessage } = useIntl()
  const { breakpoints } = useTheme()
  const matchesMobile = useMediaQuery(breakpoints.down('sm'))

  return (
    <BasicDialog
      open
      maxWidth="md"
      fullWidth
      title={
        <Typography variant="inherit" mb={-1} sx={{ mx: -1 }} color="#0c256d">
          {formatMessage({ id: 'safeup.confirmCancel' })}
        </Typography>
      }
      onClose={() => setOpenDialog(false)}
      actions={[
        {
          label: formatMessage({ id: 'safeup.cancelSafeUpPlus' }),
          onClick: () => {
            handleSetSafeUpPlus(false)
            setOpenDialog(false)
          },
          variant: 'outlined',
          fullWidth: matchesMobile,
          id: 'cancelSafeUpPlus-button',
          actionStyle: { mt: { xs: 0, sm: -2 } },
          disabled: blockingAdditionalServices.length > 0
        },
        {
          label: formatMessage({ id: 'safeup.keepSafeUpPlus' }),
          onClick: () => {
            setOpenDialog(false)
          },
          fullWidth: matchesMobile,
          id: 'dontCancelSafeUpPlus-button',
          actionStyle: { mt: { xs: 0, sm: -2 } },
        },
      ]}
    >
      <Box>
        <Typography variant="h5" mb={2}>
          {formatMessage({ id: 'safeup.safeUpDescription' })}
        </Typography>
        <Typography>
          {formatMessage(
            { id: 'safeup.cancelWarning' },
            {
              strong: chunks => <strong>{chunks}</strong>,
            },
          )}
        </Typography>
        <Box sx={containerStyle}>
          <Typography variant="h5" fontWeight="bold" color="#0c256d" mb={3}>
            {formatMessage({ id: 'safeup.safeUpPlusBenefits' })}
          </Typography>
          <Box sx={contentStyle}>
            <Box>
              <Typography variant="subtitle1" color="primary" mb={1}>
                {formatMessage({ id: 'safeup.contractDuration' })}
              </Typography>
              <Box sx={{ fill: theme => theme.palette.primary.main }}>
                <SmileImg height={44} />
              </Box>
              <Typography>{formatMessage({ id: 'safeup.peaceOfMind' })}</Typography>
            </Box>
            <Box>
              <Typography variant="subtitle1" color="primary" mb={1}>
                {formatMessage({ id: 'safeup.lowerCosts' })}
              </Typography>
              <Box sx={{ fill: theme => theme.palette.primary.main }}>
                <FileImg height={44} />
              </Box>
              <Typography>{formatMessage({ id: 'safeup.avoidHigherRepairCosts' })}</Typography>
            </Box>
          </Box>
        </Box>
        {blockingAdditionalServices.length > 0 && (
          <>
            <Typography color="error">
              {formatMessage(
                { id: 'safeup.blockingAdditionalServices' },
                {
                  strong: chunks => <strong>{chunks}</strong>,
                },
              )}
            </Typography>
            <Typography variant="h5">
              {blockingAdditionalServices.map(service => service.name).join(', ')}
            </Typography>
          </>
        )}
      </Box>
    </BasicDialog>
  )
}
